//#region  các biến mapping từ chuyển khoản kho bạc
const mappingFromBuTransfer = {
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  accounting_object_name: 'accounting_object_name',
  accounting_object_address: 'accounting_object_address',
  bank_account: 'bank_account',
  bank_name: 'bank_name',
  description: 'description',
  document_included: 'document_included',
  contract_code: 'contract_code',
  contract_id: 'contract_id',
};
// mapping với chính nó
const gridMappingFromBuTransferToMySelf = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code: 'budget_chapter_code',
  budget_provide_code: 'budget_provide_code',
  budget_kind_item_code: 'budget_kind_item_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code: 'budget_item_detail_code',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
};

const gridMappingFromBuTransfer = {
  ...gridMappingFromBuTransferToMySelf,
  budget_provide_code: 'budget_provide_code',
};
// mapping từ chuyển khoản kho bạc đến nộp tiền kho bạc
const gridMappingFromBuTransferToBaDeposit = {
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  state_amount: 'state_amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code: 'budget_chapter_code',
  budget_kind_item_code: 'budget_kind_item_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  budget_item_detail_code: 'budget_item_detail_code',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
};
// mapping từ chuyển khoản kho bạc đến chứng từ nghiệp vụ khác
const gridMappingFromBuTransferToSuGeneral = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  state_amount: 'state_amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code_debit: 'budget_chapter_code',
  budget_chapter_code_credit: 'budget_chapter_code',
  budget_kind_item_code_debit: 'budget_kind_item_code',
  budget_kind_item_code_credit: 'budget_kind_item_code',
  budget_sub_kind_item_code_credit: 'budget_sub_kind_item_code',
  budget_sub_kind_item_code_debit: 'budget_sub_kind_item_code',
  budget_item_code_credit: 'budget_item_code',
  budget_item_code_debit: 'budget_item_code',
  budget_sub_item_code_debit: 'budget_sub_item_code',
  budget_sub_item_code_credit: 'budget_sub_item_code',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code_debit: 'budget_item_detail_code',
  budget_item_detail_code_credit: 'budget_item_detail_code',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
  receipt_type: 'receipt_type',
};
//#endregion

//#region CKKB vào TKTG (nvthinh 10.05.2024)
const BuTransferDepositMaster = {
  accounting_object_bank_account: 'accounting_object_bank_account',
  accounting_object_bank_name: 'accounting_object_bank_name',
  bank_account: 'bank_account',
  bank_name: 'bank_name',
  description: 'description',
  buPlanReceipt: 'buPlanReceipt',
  bu_commitment_request_id: 'bu_commitment_request_id',
  bu_commitment_request_ref_no: 'bu_commitment_request_ref_no',
};

const BuTransferDepositMasterMapping = {
  // Lấy theo tk nhận
  bank_account: 'accounting_object_bank_account',
  bank_name: 'accounting_object_bank_name',
  description: 'description',
};

const BuTransferDepositMappingCustom = {
  ...BuTransferDepositMasterMapping,
  buPlanReceipt: 'buPlanReceipt',
};

const BuTransferDepositDetail = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_provide_code: 'budget_provide_code', // Mã dự phòng
  budget_chapter_code: 'budget_chapter_code',
  budget_kind_item_code: 'budget_kind_item_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code: 'budget_item_detail_code',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
};
//#endregion

//#region  các biến mapping từ  chi tiền gửi
const mappingFromBaWithdraw = {
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  accounting_object_name: 'accounting_object_name',
  accounting_object_address: 'accounting_object_address',
  bank_account: 'bank_account',
  bank_name: 'bank_name',
  description: 'description',
  document_included: 'document_included',
};

const gridMappingFromBaWithDraw = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code: 'budget_chapter_code',
  budget_kind_item_code: 'budget_kind_item_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code: 'budget_item_detail_code',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
};

// mapping từ chi tiền gửi đến chứng từ nghiệp vụ khác
const gridMappingFromBaWithdrawToSuGeneral = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code_debit: 'budget_chapter_code',
  budget_chapter_code_credit: 'budget_chapter_code',
  budget_kind_item_code_debit: 'budget_kind_item_code',
  budget_kind_item_code_credit: 'budget_kind_item_code',
  budget_sub_kind_item_code_credit: 'budget_sub_kind_item_code',
  budget_sub_kind_item_code_debit: 'budget_sub_kind_item_code',
  budget_item_code_credit: 'budget_item_code',
  budget_item_code_debit: 'budget_item_code',
  budget_sub_item_code_debit: 'budget_sub_item_code',
  budget_sub_item_code_credit: 'budget_sub_item_code',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code_credit: 'budget_item_detail_code',
  budget_item_detail_code_debit: 'budget_item_detail_code',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
};
// Mapping từ chi tiền gửi đến nộp tiền kho bạc
const gridMappingFromBaWithdrawToBaDeposit = {
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code: 'budget_chapter_code',
  budget_kind_item_code: 'budget_kind_item_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  budget_item_detail_code: 'budget_item_detail_code',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
};
// Mapping từ nghiệp vụ khác đến phiếu thu
const gridMappingFromDetailToCaReceipt = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  state_amount: 'state_amount',
  amount: 'amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code: 'budget_chapter_code_debit',

  budget_kind_item_code: 'budget_kind_item_code_debit',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code_debit',
  budget_item_code: 'budget_item_code_debit',
  budget_sub_item_code: 'budget_sub_item_code_debit',
  budget_sub_item_code: 'budget_sub_item_code_credit',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code: 'budget_item_detail_code_debit',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
};
// chứng từ nghiệp vụ khác mapping với chính nó
const gridMappingFromDetailToSelf = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  state_amount: 'state_amount',
  amount: 'amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code_debit: 'budget_chapter_code_debit',
  budget_chapter_code_credit: 'budget_chapter_code_credit',

  budget_kind_item_code_debit: 'budget_kind_item_code_debit',
  budget_kind_item_code_credit: 'budget_kind_item_code_credit',
  budget_sub_kind_item_code_credit: 'budget_sub_kind_item_code_credit',
  budget_sub_kind_item_code_debit: 'budget_sub_kind_item_code_debit',
  budget_item_code_credit: 'budget_item_code_credit',
  budget_item_code_debit: 'budget_item_code_debit',
  budget_sub_item_code_debit: 'budget_sub_item_code_debit',
  budget_sub_item_code_credit: 'budget_sub_item_code_credit',
  bank_account: 'bank_account',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code_credit: 'budget_item_detail_code_credit',
  budget_item_detail_code_debit: 'budget_item_detail_code_debit',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
  receipt_type: 'receipt_type',
};
// Mapping chứng từ nghiệp vụ khác đến rút tiền kho bạc
const gridMappingFromDetailToReceiptDetail = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code: 'budget_chapter_code_debit',

  budget_kind_item_code: 'budget_kind_item_code_debit',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code_debit',
  budget_item_code: 'budget_item_code_debit',
  budget_sub_item_code: 'budget_sub_item_code_debit',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code: 'budget_item_detail_code_debit',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
  sort_order: 'sort_order',
};
// Mapping từ chi tiết dvc đến rút tiền kho bạc
const gridMappingFromDvcToReceiptDetail = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_id: 'auto_business_id',
  auto_business_code: 'auto_business_code',
  description: 'description',
  amount: 'amount',
  budget_source_id: 'budget_source_id',
  budget_source_code: 'budget_source_code',
  budget_source_name: 'budget_source_name',
  budget_provide_code: 'budget_provide_code',
  budget_chapter_code: 'budget_chapter_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_sub_kind_item_id: 'budget_sub_kind_item_id',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  budget_item_detail_code: 'budget_item_detail_code',
  budget_kind_item_code: 'budget_kind_item_code',
  budget_kind_item_id: 'budget_kind_item_id',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_id: 'accounting_object_id',
  accounting_object_name: 'accounting_object_name',
  accounting_object_code: 'accounting_object_code',
  activity_id: 'activity_id',
  activity_code: 'activity_code',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_id: 'local_budget_item_id',
  local_budget_item_name: 'local_budget_item_name',
  statistic_id: 'statistic_id',
  statistic_code: 'statistic_code',
  fund_structure_id: 'fund_structure_id',
  fund_structure_code: 'fund_structure_code',
  sort_order: 'sort_order',
};

const gridMappingFromDvcToSaAccountingDetail = {
  auto_business_id: 'auto_business_id',
  auto_business_code: 'auto_business_code',
  description: 'description',
  receipt_type: 'receipt_type',
  amount: 'amount',
  budget_source_id: 'budget_source_id',
  budget_source_code: 'budget_source_code',
  budget_source_name: 'budget_source_name',
  budget_chapter_code: 'budget_chapter_code',
  budget_provide_code: 'budget_provide_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_sub_kind_item_id: 'budget_sub_kind_item_id',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  budget_item_detail_code: 'budget_item_detail_code',
  budget_kind_item_code: 'budget_kind_item_code',
  budget_kind_item_id: 'budget_kind_item_id',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_id: 'accounting_object_id',
  accounting_object_name: 'accounting_object_name',
  accounting_object_code: 'accounting_object_code',
  activity_id: 'activity_id',
  activity_code: 'activity_code',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_id: 'local_budget_item_id',
  local_budget_item_name: 'local_budget_item_name',
  statistic_id: 'statistic_id',
  statistic_code: 'statistic_code',
  fund_structure_id: 'fund_structure_id',
  fund_structure_code: 'fund_structure_code',
  sort_order: 'sort_order',
};

// Mapping từ chi tiết dvc đến rút tiền kho bạc
const gridMappingFromDvcToPaymentDetail = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_id: 'auto_business_id',
  auto_business_code: 'auto_business_code',
  description: 'description',
  amount: 'amount',
  budget_source_id: 'budget_source_id',
  budget_source_code: 'budget_source_code',
  budget_source_name: 'budget_source_name',
  budget_provide_code: 'budget_provide_code',
  budget_chapter_code: 'budget_chapter_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_sub_kind_item_id: 'budget_sub_kind_item_id',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  budget_item_detail_code: 'budget_item_detail_code',
  budget_kind_item_code: 'budget_kind_item_code',
  budget_kind_item_id: 'budget_kind_item_id',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_id: 'accounting_object_id',
  accounting_object_name: 'accounting_object_name',
  accounting_object_code: 'accounting_object_code',
  activity_id: 'activity_id',
  activity_code: 'activity_code',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_id: 'local_budget_item_id',
  local_budget_item_name: 'local_budget_item_name',
  statistic_id: 'statistic_id',
  statistic_code: 'statistic_code',
  fund_structure_id: 'fund_structure_id',
  fund_structure_code: 'fund_structure_code',
  sort_order: 'sort_order',
};

// Mappring từ chi tiết dvc đến chuyển khoản kho bạc
const gridMappingFromDvcToBuTransfer = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_id: 'auto_business_id',
  auto_business_code: 'auto_business_code',
  description: 'description',
  amount: 'amount',
  budget_source_id: 'budget_source_id',
  budget_source_code: 'budget_source_code',
  budget_source_name: 'budget_source_name',
  budget_provide_code: 'budget_provide_code',
  budget_chapter_code: 'budget_chapter_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_sub_kind_item_id: 'budget_sub_kind_item_id',
  budget_kind_item_code: 'budget_kind_item_code',
  budget_kind_item_id: 'budget_kind_item_id',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  budget_item_detail_code: 'budget_item_detail_code',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_id: 'accounting_object_id',
  accounting_object_name: 'accounting_object_name',
  accounting_object_code: 'accounting_object_code',
  activity_id: 'activity_id',
  activity_code: 'activity_code',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_id: 'local_budget_item_id',
  local_budget_item_name: 'local_budget_item_name',
  statistic_id: 'statistic_id',
  statistic_code: 'statistic_code',
  fund_structure_id: 'fund_structure_id',
  fund_structure_code: 'fund_structure_code',
  sort_order: 'sort_order',
};

// Mapping chứng từ nghiệp vụ khác đến rút tiền kho bạc
const gridMappingFromDetailToPaymentDetail = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code: 'budget_chapter_code_debit',

  budget_kind_item_code: 'budget_kind_item_code_debit',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code_debit',
  budget_item_code: 'budget_item_code_debit',
  budget_sub_item_code: 'budget_sub_item_code_debit',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code: 'budget_item_detail_code_debit',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
};
// Mapping từ nghiệp vụ khác đến nộp tiền kho bạc
const gridMappingFromDetailToDeposit = {
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  state_amount: 'state_amount',
  amount: 'amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code: 'budget_chapter_code_debit',

  budget_kind_item_code: 'budget_kind_item_code_debit',

  budget_sub_kind_item_code: 'budget_sub_kind_item_code_debit',

  budget_item_code: 'budget_item_code_debit',
  budget_sub_item_code: 'budget_sub_item_code_debit',

  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',

  budget_item_detail_code: 'budget_item_detail_code_debit',

  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
};
// Mapping từ chứng từ nghiệp vụ khác đến chuyển khoản kho bạc
const gridMappingFromDetailToBuTransfer = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  budget_chapter_code: 'budget_chapter_code_debit',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_kind_item_code: 'budget_kind_item_code_debit',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code_debit',
  budget_item_code: 'budget_item_code_debit',
  budget_sub_item_code: 'budget_sub_item_code_debit',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code: 'budget_item_detail_code_debit',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
};
//#endregion
// Mapping master
const mappingToCashDetails = {
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  accounting_object_name: 'accounting_object_name',
  accounting_object_address: 'accounting_object_address',
  bank_account: 'bank_account',
  bank_name: 'bank_name',
  description: 'description',
  document_included: 'document_included',
};
// Chứng từ nghiệp vụ khác
const mappingFromDetails = {
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  accounting_object_name: 'accounting_object_name',
  accounting_object_address: 'accounting_object_address',
  bank_account: 'bank_account',
  bank_name: 'bank_name',
  description: 'description',
};
//#region  các biến mapping từ Hạch toán chi phí lương, BH, KPCĐ
const mappingFromSAAcounting = {
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  accounting_object_name: 'accounting_object_name',
  accounting_object_address: 'accounting_object_address',
  bank_account: 'bank_account',
  bank_name: 'bank_name',
  description: 'description',
  document_included: 'document_included',
};
// mapping với chính nó
const gridMappingFromSAAcountingDetailToMySelf = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code: 'budget_chapter_code',
  budget_kind_item_code: 'budget_kind_item_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code: 'budget_item_detail_code',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
  budget_provide_code: 'budget_provide_code',
  receipt_type: 'receipt_type',
};
// Mapping từ Hạch toán lương đến Phiếu rút tiền kho bạc
const gridMappingFromAccountingToCaCashReceipt = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  state_amount: 'state_amount',
  amount: 'amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code: 'budget_chapter_code',

  budget_kind_item_code: 'budget_kind_item_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code: 'budget_item_detail_code',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
};
// mapping từ phiếu chi đến chứng từ nghiệp vụ khác
const gridMappingFromCAPaymentToSuGeneral = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  state_amount: 'state_amount',
  budget_provide_code: 'budget_provide_code',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code_debit: 'budget_chapter_code',
  budget_chapter_code_credit: 'budget_chapter_code',
  budget_kind_item_code_debit: 'budget_kind_item_code',
  budget_kind_item_code_credit: 'budget_kind_item_code',
  budget_sub_kind_item_code_credit: 'budget_sub_kind_item_code',
  budget_sub_kind_item_code_debit: 'budget_sub_kind_item_code',
  budget_item_code_credit: 'budget_item_code',
  budget_item_code_debit: 'budget_item_code',
  budget_detail_item_code_debit: 'budget_item_detail_code',
  budget_detail_item_code_credit: 'budget_item_detail_code',
  budget_item_detail_code_debit: 'budget_item_detail_code',
  budget_item_detail_code_credit: 'budget_item_detail_code',

  budget_sub_item_code_debit: 'budget_sub_item_code',
  budget_sub_item_code_credit: 'budget_sub_item_code',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code: 'budget_item_detail_code',
  quantity: 'quantity',
  real_unit_price: 'real_unit_price',
  unit_price: 'unit_price',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name',
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
};

// mapping từ phiếu chi đến phiếu thu và phiếu rút tiền kho bạc
const gridMappingFromCaPaymentToCaReceipt = {
  org_voucher_no: 'org_voucher_no',
  org_voucher_date: 'org_voucher_date',
  inv_no: 'inv_no',
  inv_date: 'inv_date',
  auto_business_code: 'auto_business_code',
  description: 'description',
  debit_account: 'debit_account',
  credit_account: 'credit_account',
  amount: 'amount',
  budget_source_name: 'budget_source_name',
  budget_source_id: 'budget_source_id',
  budget_chapter_code: 'budget_chapter_code',
  budget_kind_item_code: 'budget_kind_item_code',
  budget_sub_kind_item_code: 'budget_sub_kind_item_code',
  budget_item_code: 'budget_item_code',
  budget_sub_item_code: 'budget_sub_item_code',
  method_distribute_id: 'method_distribute_id',
  method_distribute_name: 'method_distribute_name',
  budget_item_detail_code: 'budget_item_detail_code',
  cash_withdraw_type_id: 'cash_withdraw_type_id',
  cash_withdraw_type_name: 'cash_withdraw_type_name',
  project_id: 'project_id',
  project_code: 'project_code',
  accounting_object_code: 'accounting_object_code',
  accounting_object_id: 'accounting_object_id',
  activity_code: 'activity_code',
  activity_id: 'activity_id',
  fund_id: 'fund_id',
  fund_name: 'fund_name',
  local_budget_item_name: 'local_budget_item_name', // phiếu thu không có chỗ này phiếu rút tiền có nhưng trên grid phiếu thu không hiện
  statistic_code: 'statistic_code',
  statistic_id: 'statistic_id',
  fund_structure_code: 'fund_structure_code',
  fund_structure_id: 'fund_structure_id',
  budget_provide_code: 'budget_provide_code',
};
//#endregion
/**
 * Trạng thái của model
 */
export default {
  // Chuyển khoản kho bạc
  BuTransferDetails: {
    // Phiếu thu
    CaCashReceiptDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu chi
    CaCashPaymentDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu rút tiền kho bạc -- đang giống với phiếu thu sau phải đổi
    CaCashReceiptDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu nộp tiền kho bạc
    BADepositDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransferToBaDeposit,
    },
    // Chuyển khoản kho bạc
    BuTransferDetails: {
      ...mappingFromBuTransfer,
      bu_commitment_request_ref_no: 'bu_commitment_request_ref_no',
      GridMapping: gridMappingFromBuTransferToMySelf,
    },
    // Chứng từ nghiệp vụ khác
    Details: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransferToSuGeneral,
    },
  },

  // CKKB vào TKTG (nvthinh 8.5.2024)
  BuTransferDeposit: {
    // Chuyển khoản kho bạc vào TKKG
    BuTransferDetails: {
      ...BuTransferDepositMaster,
      GridMapping: BuTransferDepositDetail,
    },
    // Phiếu thu, Phiếu rút tiền kho bạc
    CaCashReceiptDetails: {
      ...BuTransferDepositMappingCustom,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu chi
    CaCashPaymentDetails: {
      ...BuTransferDepositMasterMapping,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu nộp tiền kho bạc
    BADepositDetails: {
      ...BuTransferDepositMasterMapping,
      GridMapping: gridMappingFromBuTransferToBaDeposit,
    },
    // Chứng từ nghiệp vụ khác
    Details: {
      ...BuTransferDepositMappingCustom,
      GridMapping: gridMappingFromBuTransferToSuGeneral,
    },
  },

  // Chi tiền gửi
  BAWithdrawDetails: {
    // Phiếu thu
    CaCashReceiptDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Chi tiền gửi
    BAWithdrawDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu rút tiền kho bạc
    CaCashReceiptDetails: {
      ...mappingFromBaWithdraw,
      GridMapping: gridMappingFromBaWithDraw,
    },
    Details: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBaWithdrawToSuGeneral,
    },
    // Phiếu nộp tiền kho bạc
    BADepositDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBaWithdrawToBaDeposit,
    },
    // Chuyển khoản kho bạc
    BuTransferDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
  },
  // Chứng từ nghiệp vụ khác
  Details: {
    // Phiếu thu
    CaCashReceiptDetails: {
      ...mappingFromDetails,
      GridMapping: gridMappingFromDetailToCaReceipt,
    },
    // Phiếu chi
    CaCashPaymentDetails: {
      ...mappingFromDetails,
      GridMapping: gridMappingFromDetailToPaymentDetail,
    },
    // Phiếu rút tiền kho bạc
    // Phiếu chi giống với rút tiền kho bạc này
    CaCashReceiptDetails: {
      ...mappingFromDetails,
      GridMapping: {...gridMappingFromDetailToReceiptDetail, state_amount: 'state_amount'},
    },
    // Chứng từ nghiệp vụ khác
    Details: {
      ...mappingFromDetails,
      GridMapping: gridMappingFromDetailToSelf,
    },
    // Phiếu nộp tiền kho bạc
    BADepositDetails: {
      ...mappingFromDetails,
      GridMapping: gridMappingFromDetailToDeposit,
    },
    // Chuyển khoản kho bạc
    BuTransferDetails: {
      ...mappingFromDetails,
      GridMapping: gridMappingFromDetailToBuTransfer,
    },
  },
  // Phiếu nộp tiền kho bạc
  BADepositDetails: {
    // Phiếu thu, phiếu chi
    CaCashReceiptDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    CaCashPaymentDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu rút tiền kho bạc
    CaCashReceiptDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu nộp tiền kho bạc
    BADepositDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransferToBaDeposit,
    },
    // Chuyển khoản kho bạc
    BuTransferDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransferToMySelf,
    },
    // Chứng từ nghiệp vụ khác
    Details: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransferToSuGeneral,
    },
  },
  CaCashReceiptDetails: {
    // Phiếu thu, phiếu chi
    CaCashReceiptDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    CaCashPaymentDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu rút tiền kho bạc
    CaCashReceiptDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu nộp tiền kho bạc
    BADepositDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransferToBaDeposit,
    },
    // Chuyển khoản kho bạc
    BuTransferDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransferToMySelf,
    },
    // Chứng từ nghiệp vụ khác
    Details: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransferToSuGeneral,
    },
  },
  // Phiếu thu tiền
  CashDetails: {
    // Phiếu thu, phiếu chi
    CaCashReceiptDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    CaCashPaymentDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu rút tiền kho bạc
    CaCashReceiptDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu nộp tiền kho bạc
    BADepositDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransferToBaDeposit,
    },
    // Chuyển khoản kho bạc
    BuTransferDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransferToMySelf,
    },
    // Chứng từ nghiệp vụ khác
    Details: {
      ...mappingFromBuTransfer,
      GridMapping: {...gridMappingFromBuTransferToSuGeneral},
    },
  },
  // Hạch toán chi phí lương, BH, KPCĐ
  SaAcountingDetails: {
    // Hạch toán chi phí lương, BH, KPCĐ
    SaAcountingDetails: {
      ...mappingFromSAAcounting,
      bu_commitment_request_ref_no: 'bu_commitment_request_ref_no',
      GridMapping: gridMappingFromSAAcountingDetailToMySelf,
    },
    // Phiếu rút tiền kho bạc
    CaCashReceiptDetails: {
      ...mappingFromSAAcounting,
      GridMapping: gridMappingFromAccountingToCaCashReceipt,
    },
  },

  SalarySalagov: {
    Master: {
      ref_id: 'SalaryVoucherID',
      ref_no: 'SalaryVoucherCode',
      ref_type: 'PaperType',
      ref_date: 'VoucherDate',
      posted_date: 'AccountDate',
      payment_account: 'BankPaymentNumber',
      accounting_object_bank_account: 'BankReceivingNumber',
      description: 'VoucherContent',
    },
    Details: {
      ref_id: 'SalaryVoucherID',
      ref_detail_id: 'SalaryVoucherDetailID',
      amount: 'Amount',
      description: 'VoucherDetailContent',
      budget_source_code: 'PaymentSourceCode',
      budget_chapter_code: 'BudgetChapterCode',
      budget_sub_kind_item_code: 'BudgetKindItemCode',
      budget_sub_item_code: 'BudgetItemCode',
      budget_item_detail_code: 'BudgetUnitItemCode',
    },
  },
  // Phiếu rút tiền kho bạc từ dvc
  DvcCaCashReceipt: {
    Master: {
      accounting_object_id: 'receive_money_id',
      accounting_object_code: 'receive_money_code',
      accounting_object_name: 'receive_money_name',
      accounting_object_address: 'receive_money_address',
      dvc_cash_with_draw_id: 'dvc_cash_with_draw_id',
      description: 'journal_memo',
      bank_account: 'receive_money_bank_account',
      bank_name: 'receive_money_bank_name',
    },
    Details: gridMappingFromDvcToReceiptDetail,
  },

  DvcSaAcccounting: {
    Master: {
      accounting_object_id: 'receive_money_id',
      accounting_object_code: 'receive_money_code',
      accounting_object_name: 'receive_money_name',
      accounting_object_address: 'receive_money_address',
      dvc_cash_with_draw_id: 'dvc_cash_with_draw_id',
      description: 'journal_memo',
      bank_account: 'receive_money_bank_account',
      bank_name: 'receive_money_bank_name',
    },
    Details: gridMappingFromDvcToSaAccountingDetail,
  },

  // Phiếu chi
  DvcCaCashPayment: {
    Master: {
      accounting_object_id: 'receive_money_id',
      accounting_object_code: 'receive_money_code',
      accounting_object_name: 'receive_money_name',
      accounting_object_address: 'receive_money_address',
      dvc_cash_with_draw_id: 'dvc_cash_with_draw_id',
      description: 'journal_memo',
      bank_account: 'receive_money_bank_account',
      bank_name: 'receive_money_bank_name',
    },
    Details: gridMappingFromDvcToPaymentDetail,
  },

  // Phiếu chuyển khoản kho bạc từ dvc
  DvcBuTransfer: {
    Master: {
      accounting_object_id: 'receive_money_id',
      accounting_object_code: 'receive_money_code',
      accounting_object_name: 'receive_money_name',
      accounting_object_address: 'receive_money_address',
      dvc_cash_with_draw_id: 'dvc_cash_with_draw_id',
      description: 'journal_memo',
      bank_account: 'receive_money_bank_account',
      bank_name: 'receive_money_bank_name',
    },
    Details: gridMappingFromDvcToBuTransfer,
  },
  // Phiếu CKKN vào TK tiền gửi từ DVC
  DvcBuTransferDeposit: {
    Master: {
      accounting_object_bank_id: 'receive_money_id',
      accounting_object_bank_account: 'receive_money_bank_account',
      accounting_object_bank_name: 'receive_money_bank_name',
      dvc_cash_with_draw_id: 'dvc_cash_with_draw_id',
      description: 'journal_memo',
      bank_account: 'state_treasury_account',
      bank_name: 'state_treasury_name',
    },
    Details: gridMappingFromDvcToBuTransfer,
  },
  // Phiếu nộp tiền kho bạc từ DVC
  DvcBADeposit: {
    Master: {
      accounting_object_id: 'accounting_object_name_sent_id',
      accounting_object_code: 'accounting_object_name_sent_code',
      accounting_object_name: 'accounting_object_name_sent_name',
      accounting_object_address: 'accounting_object_address',
      dvc_cash_with_draw_id: 'dvc_cash_with_draw_id',
      accounting_object_bank_id: 'receive_money_id',
      accounting_object_bank_account: 'receive_money_bank_account',
      accounting_object_bank_name: 'receive_money_bank_name',
      dvc_cash_with_draw_id: 'dvc_cash_with_draw_id',
      description: 'journal_memo',
      bank_account: 'estimate_company_bank_account',
      bank_name: 'estimate_company_name',
    },
    Details: gridMappingFromDvcToBuTransfer,
  },
  // Phiếu chi tiền gửi từ DVC
  DvcBAWithDraw: {
    Master: {
      accounting_object_id: 'receive_money_id',
      accounting_object_code: 'receive_money_code',
      accounting_object_name: 'receive_money_name',
      accounting_object_address: 'accounting_object_address',
      dvc_cash_with_draw_id: 'dvc_cash_with_draw_id',
      accounting_object_bank_id: 'receive_money_id',
      accounting_object_bank_account: 'receive_money_bank_account',
      accounting_object_bank_name: 'receive_money_bank_name',
      dvc_cash_with_draw_id: 'dvc_cash_with_draw_id',
      description: 'journal_memo',
      bank_account: 'bank_account',
      bank_name: 'bank_name',
    },
    Details: gridMappingFromBaWithDraw,
  },
  CaCashPaymentDetails: {
    // Phiếu thu, phiếu rút tiền kho bạc
    CaCashReceiptDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromCaPaymentToCaReceipt,
    },
    // Phiếu chi
    CaCashPaymentDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Phiếu nộp tiền kho bạc
    BADepositDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromCaPaymentToCaReceipt,
    },
    // Chuyển khoản kho bạc
    BuTransferDetails: {
      ...mappingFromBuTransfer,
      GridMapping: gridMappingFromBuTransfer,
    },
    // Chứng từ nghiệp vụ khác
    Details: {
      ...mappingFromDetails,
      GridMapping: gridMappingFromCAPaymentToSuGeneral,
    },
  },
};
